import React from 'react';
import PublicEstablishmentsList from '../components/publico/PublicEstablishmentsList';

const HomePage = () => {
  return <PublicEstablishmentsList />;
};

export default HomePage;
